import { Languages } from "src/common/descriptions/types";
import { User } from "src/common/models/user";

export interface SessionData {
    accessToken?: string,
    user?: User
    language?: Languages
}

export enum SessionDataField {
    ACCESS_TOKEN = 'ACCESS_TOKEN',
    USER = 'USER',
    SYS_LANG = 'SYS_LANG',
}